// src/pages/DashboardProject/JobDetailPageWrapper.tsx
import React from "react";
import { Container } from "reactstrap";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import JobDetailPage from "./JobDetailPage";

const JobDetailPageWrapper: React.FC = () => {
    return (
        <React.Fragment>
            <Header />
            <Container>
                <JobDetailPage />
            </Container>
            <Footer />
        </React.Fragment>
    );
};

export default JobDetailPageWrapper;